module.exports = __webpack_public_path__ + "img/bg-personal-detail.0487db82.png";